import {
  Checkbox as ChakraCheckbox,
  CheckboxProps as ChakraCheckboxProps,
  FormControl,
  FormErrorMessage,
} from '@chakra-ui/react';
import React from 'react';
import { useFormContext } from 'react-hook-form';

interface ICheckboxProps extends Omit<ChakraCheckboxProps, 'name'> {
  name: string;
  label?: string;
}

export const Checkbox: React.FC<ICheckboxProps> = ({
  name,
  label,
  ...rest
}) => {
  const {
    register,
    formState: { errors },
  } = useFormContext();

  return (
    <FormControl isInvalid={!!errors[name]}>
      <ChakraCheckbox
        id={name}
        {...register(name)}
        {...rest}
        fontWeight="semibold"
      >
        {label}
      </ChakraCheckbox>
      <FormErrorMessage>
        {errors?.[name] && (errors[name]?.message as string)}
      </FormErrorMessage>
    </FormControl>
  );
};
